import React from 'react';
import { OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { sectionProps } from 'src/tools/constant';

const Option = OriSelect.Option;

const FieldSelector = (props) => {
  const { disabled, options, title, name } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={title}>
        <Field name={name}>
          <OriSelect disabled={disabled} size='large'>
            {options.map((i) => {
              const { label, value } = i;
              return (
                <Option value={value} key={value}>
                  {label}
                </Option>
              );
            })}
          </OriSelect>
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default FieldSelector;
